module.exports = __webpack_public_path__ + "static/media/free-3.71371d83.jpg";